module.exports = __webpack_public_path__ + "static/media/profile-cover.9992e0ee.jpg";